<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Audit' }">Audit</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Audit void'}">
          {{ $root.getHeader() }} Audit report for Voided items
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-table :data="voidedItems" v-loading="loading">
      <el-table-column label="Customer" prop="customer[0].company"></el-table-column>
      <el-table-column label="Voided At" :width="100">
        <template slot-scope="scope">
          {{ new Date(scope.row.lineItems.voidedAt).toLocaleString() }}
        </template>
      </el-table-column>
      <el-table-column
        label="Amount" prop="lineItems.voidValue"
        :width="100"
        :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
      ></el-table-column>
      <el-table-column label="Voided By" prop="lineItems.voidedBy"></el-table-column>
      <el-table-column label="Description" prop="lineItems.description" :width="350"></el-table-column>
      <el-table-column label="Void Reason" prop="lineItems.voidReason" :width="350"></el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import axios from 'axios';
import { LEASING_API } from '../env';

export default {
  name: 'AuditVoid',
  props: {
    facility: { type: String, required: true }
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getVoidItems();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getVoidItems();
    this.loading = false;
  },
  data() {
    return {
      voidedItems: [],
      loading: false,
    };
  },
  methods: {
    async getVoidItems() {
      const response = await axios.get(`${LEASING_API}/v1/${this.facility}/void/items`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });

      this.voidedItems = response.data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AuditVoid.vue